<template>
  <div>
    <div class="footer">
      <div class="footer-content">
        <div class="footer-logo">
          <img
            src="@/assets/images/zy_write.png"
            alt
            class="footerlogo"
            draggable="false"
          />
        </div>
        <div class="footer-info">
          <div class="info-row">
            <div class="company-names">
              <div class="company-item">
                <div class="company-name">上海早鹰培优信息技术有限公司</div>
                <div class="company-address">上海市闵行区集心路268号二楼  151-021-11688</div>
              </div>
              <div class="company-item">
                <div class="company-name">江苏早鹰培优信息技术有限公司</div>
                <div class="company-address">江苏省南通市中央公园广场1401室  0513-83882000</div>
              </div>
              <div class="company-item">
                <div class="company-name">南通早鹰文化发展有限公司</div>
                <div class="company-address">江苏省南通市启东市人民中路773-2号</div>
              </div>
              <div class="company-item">
                <div class="company-name">青岛早鹰信息科技有限公司</div>
                <div class="company-address">
                  山东省青岛市西海岸新区（黄岛）映山红路1117号二楼
                </div>
              </div>
            </div>
            <div class="qrcode-section">
              <div class="qrcode-section-item">
                <div class="qrcode-item">
                  <img src="@/assets/images/ZYJT.jpg" width="100" />
                  <p style="font-size: 13px">早鹰集团公众号</p>
                </div>
                <div class="qrcode-item">
                  <img src="@/assets/images/ZYPYDY.png" width="100" />
                  <p style="font-size: 13px">早鹰培优抖音号</p>
                </div>
              </div>
            </div>
          </div>
          <div class="contact-email">业务咨询邮箱: contact@zaoying.com</div>
        </div>
      </div>
      <hr class="footerhr" />
      <div class="footercopyright">
        <span>Copyright © 2024 Zao Ying Group Limited Liability Company. All rights reserved.</span>
        <span><a href="https://beian.miit.gov.cn/" target="_blank">备案号：沪ICP备2022000823号</a></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
.footer {
  width: 100%;
  background-color: #111827;
  padding: 30px 0px;
}

.footer-content {
  width: 70%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0;
  align-items: stretch;
}

.footer-logo {
  display: flex;
  align-items: flex-start;
}

.footerlogo {
  width: 200px;
  display: block;
}

.footer-info {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
}

.info-row {
  display: flex;
  align-items: flex-start;
  gap: 40px;
  flex-grow: 0;
  flex-shrink: 0;
}

.company-names {
  display: flex;
  flex-direction: column;
  gap: 20px;
  color: #ffffff;
  font-weight: bold;
  white-space: nowrap;
  align-items: flex-start;
  text-align: left;
}

.company-item {
  display: flex;
  font-size: 14px;
  flex-direction: column;
  gap: 5px;
}

.company-name {
  color: #ffffff;
  font-weight: bold;
}

.company-address {
  color: #ffffff;
  font-size: 12px;
  font-weight: normal;
  opacity: 0.8;
}

.qrcode-section {
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding-left: 20px;
  align-items: flex-start;
}
.qrcode-section-item{
  display: flex;
  gap: 30px;
  align-items: flex-start;
}

.qrcode-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: #ffffff;
}

.qrcode-item p {
  margin: 10px 0 0 0;
  font-size: 15px;
  color: #ffffff;
}

.contact-email {
  display: flex;
  color: #ffffff;
  white-space: nowrap;
  font-size: 13px;
  width: 100%;
  margin-top: -16px;
  justify-content: flex-end;
  text-align: left;
}

.footerhr {
  width: 70%;
  margin: 20px auto;
}

.footercopyright {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 70%;
  margin: 0 auto;
  color: #ffffff;
  font-size: 12px;
}
.footercopyright span a{
  color: #ffffff;
  text-decoration: none;
  cursor: pointer;
}
</style>